
import { BotaoAcessarComponent } from './botao-acessar.component';

export const BOTOES = [
    BotaoAcessarComponent
  ];